// import {
//   AfterViewInit,
//   Component,
//   Input,
//   OnInit,
// } from "@angular/core";
// import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

// @Component({
//   selector: "app-partcountchart",
//   templateUrl: "./partcountchart.component.html",
//   styleUrls: ["./partcountchart.component.scss"],
// })


// export class PartcountchartComponent implements OnInit, AfterViewInit {
//   @Input() gaugeArray: any;
//   ganttChart: any = [];
//   echartsInstance: any;
//   color: any = [];
//   breadCrumbItems: Array<{}>;
//   option: any;
//   machineInfo:any;
//   partcountType:any;
//   userData:any;
//   role:string;
//   constructor(    private modalService: NgbModal) {
//     this.machineInfo = JSON.parse(sessionStorage.getItem("machineInfio"));
//     this.partcountType = this.machineInfo['partcountType'];
//     this.userData = JSON.parse(sessionStorage.getItem("currentUser"));
//     this.role = this.userData["user"]["role"];
//    }

//   ngOnInit(): void {
//     this.breadCrumbItems = [
//       { label: "Charts" },
//       { label: "E - Chart", active: true },
//     ];

//     if (this.gaugeArray["hour"].length != 0) {
//       this.plotHourlychart(this.gaugeArray);
//     }
//   }
//   ngOnChanges(): void {
//     if (this.gaugeArray["hour"].length != 0) {
//       this.color = [];
//       this.gaugeArray["hour"].forEach((all) => {
//         this.color.push(this.getRandomColor());
//       });
//       this.plotHourlychart(this.gaugeArray);
//     }
//   }
//   ngAfterViewInit(): void { }
//   getRandomColor(): string {
//     return "#" + Math.floor(Math.random() * 16777215).toString(16);
//   }

//   get consolidatedTableData() {
//     if (!this.gaugeArray['partwise_info'] || !Array.isArray(this.gaugeArray['partwise_info'])) return [];

//     const flatList: any[] = [];
//     this.gaugeArray['partwise_info'].forEach((hourSlot: any[]) => {
//       if (!hourSlot || hourSlot.length === 0) return;
//       hourSlot.forEach(entry => flatList.push({ ...entry }));
//     });

//     if (flatList.length === 0) return [];

//     // Merge only CONSECUTIVE entries with the same programName
//     const merged: any[] = [];
//     let current = { ...flatList[0] };

//     for (let i = 1; i < flatList.length; i++) {
//       const entry = flatList[i];

//       if (entry.programName === current.programName) {
//         // ✅ Same program consecutive → merge
//         current.partProduced += entry.partProduced || 0;
//         current.partRejected += entry.partRejected || 0;
//         current.PIN1_count   += entry.PIN1_count   || 0;
//         current.PIN2_count   += entry.PIN2_count   || 0;
//         current.plannedPart  += entry.plannedPart  || 0;
//         // Keep earliest startTime and latest endTime
//         if (entry.startTime < current.startTime) current.startTime = entry.startTime;
//         if (entry.endTime   > current.endTime)   current.endTime   = entry.endTime;
//       } else {
//         // ✅ Different program → push current, start new
//         merged.push(current);
//         current = { ...entry };
//       }
//     }
//     merged.push(current); // push last item
//     return merged;
//   }
// getOperationLabel(programName: string): string {
//   const op = programName.substring(programName.lastIndexOf('-') + 1);
//   return op === '1' ? 'Top' : 'Bottom';
// }
// getTotalConsolidated(field: string): number {
//   return this.consolidatedTableData.reduce((sum, row) => sum + (row[field] || 0), 0);
// }

// chartRawData:any;
//   plotHourlychart(data) {
//     this.chartRawData =data;
//   const hours = data.hour;
//   const partwiseInfo = data.partwise_info || [];
//   const partCount = data.partcount || [];

//   const colorProgram = "#6CA651";
//   const colorSimple = "#08bdba";

//   const finalHourlyArray = partCount.map((count, index) => {
//     const list = partwiseInfo[index] || [];

//     if (list.length > 0) {
//       return list.reduce(
//         (sum, item) => sum + (item.partProduced || 0),
//         0
//       );
//     }

//     return count || 0;
//   });

//   const seriesData = finalHourlyArray.map((value, index) => {
//     const hasProgramData = partwiseInfo[index]?.length > 0;

//     return {
//       value,
//       itemStyle: {
//         color: hasProgramData ? colorProgram : colorSimple
//       },
//       emphasis: {
//         itemStyle: {
//           color: hasProgramData ? colorProgram : colorSimple
//         }
//       }
//     };
//   });

//   const tooltipFormatter = (params) => {
//     let html = `<b>${params[0].axisValue}</b><br/>`;

//     const hourIndex = params[0].dataIndex;
//     const list = partwiseInfo[hourIndex] || [];

//     if (list.length > 0) {
//       list.forEach(info => {
//         html += `
//           <b>${info.programName}</b><br/>
//           Produced: ${info.partProduced}<br/><br/>
//         `;
//       });
//     } else {
//       html += `
//         <b>Part Count</b><br/>
//         Produced: ${partCount[hourIndex] || 0}<br/>
//       `;
//     }

//     return html;
//   };

//   this.option = {
//     xAxis: {
//       name: "(hrs)",
//       type: "category",
//       data: hours,
//       splitLine: { show: false }
//     },
//     yAxis: {
//       type: "value",
//       splitLine: { show: false },
//       name: "(count)",
//       nameLocation: "middle",
//       nameGap: 40
//     },
//     grid: {
//       top: "10%",
//       left: "3%",
//       right: "5%",
//       bottom: 80,  
//       containLabel: true
//     },
//     tooltip: {
//       trigger: "axis",
//       formatter: tooltipFormatter,
//       backgroundColor: "#fff",
//       borderColor: "#ccc",
//       borderWidth: 1,
//       textStyle: { color: "#333", fontSize: 12 }
//     },
//     series: [
//       {
//         name: "Part Count",
//         type: "bar",
//         data: seriesData,
//         label: { show: true, position: "top" }
//       }
//     ]
//   };
// }
// partBreakdownOption:any
// onChartClick(event: any, temp: any) {

//     if (!this.chartRawData?.hasOwnProperty('pin2_count')) {
//     console.log("pin2_count not available. Chart not opened.");
//     return;
//   }

//   const hours = this.chartRawData?.hour || [];
//   const partwiseInfo = this.chartRawData?.partwise_info || [];
//   const partCount1Array = this.chartRawData?.pin1_count || [];
//   const partCount2Array = this.chartRawData?.pin2_count || [];

//   const colorProgram = "#6CA651";
//   const colorSimple = "#08bdba";

//   const part1Series = [];
//   const part2Series = [];

//   hours.forEach((_, index) => {

//     const list = partwiseInfo[index] || [];
//     const hasProgramData = list.length > 0;

//     let part1 = 0;
//     let part2 = 0;

//     if (hasProgramData) {
//       part1 = list.reduce(
//         (sum, item) => sum + (item.PIN1_count || 0), 0
//       );

//       part2 = list.reduce(
//         (sum, item) => sum + (item.PIN2_count || 0), 0
//       );
//     } else {
//       part1 = partCount1Array[index] || 0;
//       part2 = partCount2Array[index] || 0;
//     }

//     part1Series.push({
//       value: part1,
//       itemStyle: {
//         color: hasProgramData ? colorProgram : colorSimple
//       }
//     });

//     part2Series.push({
//       value: part2,
//       itemStyle: {
//         color: hasProgramData ? colorProgram : colorSimple
//       }
//     });

//   });

//   this.partBreakdownOption = {
//     tooltip: { trigger: "axis", 
//        backgroundColor: "#fff",
//       borderColor: "#ccc",
//       borderWidth: 1,
//       textStyle: { color: "#333", fontSize: 12 } },
//     legend: { data: ["Part 1", "Part 2"] },
//     xAxis: {
//       type: "category",
//       data: hours,
//       name: "(hrs)"
//     },
//     yAxis: {
//       type: "value",
//       name: "(count)"
//     },
//     grid: {
//       top: "10%",
//       left: "3%",
//       right: "5%",
//       bottom: 80,
//       containLabel: true
//     },
//     series: [
//       {
//         name: "Partcount 1",
//         type: "bar",
//         data: part1Series,
//         label: { show: true, position: "top" }
//       },
//       {
//         name: "Partcount 2",
//         type: "bar",
//         data: part2Series,
//         label: { show: true, position: "top" }
//       }
//     ]
//   };

//   this.modalService.open(temp, {
//   centered: true,
//   size: 'xl'
// });

// }


// }




import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-partcountchart",
  templateUrl: "./partcountchart.component.html",
  styleUrls: ["./partcountchart.component.scss"],
})
export class PartcountchartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() gaugeArray: any;

  option: any;
  partBreakdownOption: any;
  partcountType: string;
  role: string;

  // Cached — computed once, not on every CD cycle
  consolidatedTableData: any[] = [];
  expandedRow: number | null = null;

  private chartRawData: any;
  private readonly COLOR_PROGRAM = "#6CA651";
  private readonly COLOR_SIMPLE = "#08bdba";

  constructor(private modalService: NgbModal) {
    const machineInfo = JSON.parse(sessionStorage.getItem("machineInfio") || "{}");
    this.partcountType = machineInfo["partcountType"] ?? "";

    const userData = JSON.parse(sessionStorage.getItem("currentUser") || "{}");
    this.role = userData?.user?.role ?? "";
  }

  ngOnInit(): void {
    this.initialize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["gaugeArray"]) {
      this.initialize();
    }
  }

  ngOnDestroy(): void {
    // Release references to prevent memory leaks
    this.chartRawData = null;
    this.consolidatedTableData = [];
    this.option = null;
    this.partBreakdownOption = null;
     this.expandedRow = null;
  }

  

  // Called once — result stored in property, not recomputed on every CD tick
  private buildConsolidatedTableData(): any[] {
    const partwiseInfo = this.gaugeArray?.["partwise_info"];
    if (!Array.isArray(partwiseInfo) || partwiseInfo.length === 0) return [];

    // Flatten all hourly slots
    const flatList: any[] = [];
    for (const hourSlot of partwiseInfo) {
      if (!Array.isArray(hourSlot) || hourSlot.length === 0) continue;
      for (const entry of hourSlot) {
        flatList.push(entry);
      }
    }

    if (flatList.length === 0) return [];

    // Merge consecutive entries with the same programName
    const merged: any[] = [];
    let current = this.cloneEntry(flatList[0]);

    for (let i = 1; i < flatList.length; i++) {
      const entry = flatList[i];
      if (entry.programName === current.programName) {
        current.partProduced  += entry.partProduced  || 0;
        current.partRejected  += entry.partRejected  || 0;
        current.PIN1_count    += entry.PIN1_count    || 0;
        current.PIN2_count    += entry.PIN2_count    || 0;
        current.plannedPart   += entry.plannedPart   || 0;
        if (entry.rejectedPartIds?.length) {
          current.rejectedPartIds.push(...entry.rejectedPartIds);
        }
        if (entry.startTime < current.startTime) current.startTime = entry.startTime;
        if (entry.endTime   > current.endTime)   current.endTime   = entry.endTime;
      } else {
        merged.push(current);
        current = this.cloneEntry(entry);
      }
    }
    merged.push(current);
    return merged;
  }

  private cloneEntry(entry: any): any {
    return {
      programName:    entry.programName,
      partProduced:   entry.partProduced  || 0,
      partRejected:   entry.partRejected  || 0,
      PIN1_count:     entry.PIN1_count    || 0,
      PIN2_count:     entry.PIN2_count    || 0,
      plannedPart:    entry.plannedPart   || 0,
      startTime:      entry.startTime,
      endTime:        entry.endTime,
      // Shallow copy — avoids deep-cloning the whole array each merge step
      rejectedPartIds: entry.rejectedPartIds ? [...entry.rejectedPartIds] : [],
    };
  }

  // Replace toggleRow and isExpanded:
toggleRow(index: number): void {
  this.expandedRow = this.expandedRow === index ? null : index;
}

isExpanded(index: number): boolean {
  return this.expandedRow === index;
}

  getOperationLabel(programName: string): string {
    const op = programName.substring(programName.lastIndexOf("-") + 1);
    return op === "1" ? "Top" : "Bottom";
  }

private initialize(): void {
  this.expandedRow = null;   // was: this.expandedRows.clear()
  this.consolidatedTableData = this.buildConsolidatedTableData();
  console.log("Consolidated Table Data:", this.consolidatedTableData);
  if (this.gaugeArray?.['hour']?.length) {
    this.plotHourlychart(this.gaugeArray);
  }
}


  private plotHourlychart(data: any): void {
    this.chartRawData = data;
    const hours: any[]       = data.hour       || [];
    const partwiseInfo: any[] = data.partwise_info || [];
    const partCount: any[]   = data.partcount   || [];

    const seriesData = partCount.map((count: number, index: number) => {
      const list = partwiseInfo[index];
      const hasProgramData = Array.isArray(list) && list.length > 0;
      const value = hasProgramData
        ? list.reduce((sum: number, item: any) => sum + (item.partProduced || 0), 0)
        : count || 0;

      const color = hasProgramData ? this.COLOR_PROGRAM : this.COLOR_SIMPLE;
      return { value, itemStyle: { color }, emphasis: { itemStyle: { color } } };
    });

    this.option = {
      xAxis: {
        name: "(hrs)",
        type: "category",
        data: hours,
        splitLine: { show: false },
      },
      yAxis: {
        type: "value",
        splitLine: { show: false },
        name: "(count)",
        nameLocation: "middle",
        nameGap: 40,
      },
      grid: { top: "10%", left: "3%", right: "5%", bottom: 80, containLabel: true },
      tooltip: {
        trigger: "axis",
        formatter: (params: any) => {
          let html = `<b>${params[0].axisValue}</b><br/>`;
          const list = partwiseInfo[params[0].dataIndex] || [];
          if (list.length > 0) {
            list.forEach((info: any) => {
              html += `<b>${info.programName}</b><br/>Produced: ${info.partProduced}<br/><br/>`;
            });
          } else {
            html += `<b>Part Count</b><br/>Produced: ${partCount[params[0].dataIndex] || 0}<br/>`;
          }
          return html;
        },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
      },
      series: [{
        name: "Part Count",
        type: "bar",
        data: seriesData,
        label: { show: true, position: "top" },
      }],
    };
  }

  onChartClick(event: any, temp: any): void {
    if (!this.chartRawData?.hasOwnProperty("pin2_count")) return;

    const hours: any[]        = this.chartRawData.hour            || [];
    const partwiseInfo: any[] = this.chartRawData.partwise_info   || [];
    const partCount1: any[]   = this.chartRawData.pin1_count      || [];
    const partCount2: any[]   = this.chartRawData.pin2_count      || [];

    const part1Series: any[] = [];
    const part2Series: any[] = [];

    for (let index = 0; index < hours.length; index++) {
      const list = partwiseInfo[index];
      const hasProgramData = Array.isArray(list) && list.length > 0;
      const color = hasProgramData ? this.COLOR_PROGRAM : this.COLOR_SIMPLE;

      let p1 = 0, p2 = 0;
      if (hasProgramData) {
        for (const item of list) {
          p1 += item.PIN1_count || 0;
          p2 += item.PIN2_count || 0;
        }
      } else {
        p1 = partCount1[index] || 0;
        p2 = partCount2[index] || 0;
      }

      part1Series.push({ value: p1, itemStyle: { color } });
      part2Series.push({ value: p2, itemStyle: { color } });
    }

    this.partBreakdownOption = {
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
      },
      legend: { data: ["Partcount 1", "Partcount 2"] },
      xAxis: { type: "category", data: hours, name: "(hrs)" },
      yAxis: { type: "value", name: "(count)" },
      grid: { top: "10%", left: "3%", right: "5%", bottom: 80, containLabel: true },
      series: [
        {
          name: "Partcount 1", type: "bar", data: part1Series,
          label: { show: true, position: "top" },
        },
        {
          name: "Partcount 2", type: "bar", data: part2Series,
          label: { show: true, position: "top" },
        },
      ],
    };

    this.modalService.open(temp, { centered: true, size: "xl" });
  }
}